import { DatePipe } from '@angular/common';
import { FormatNumberPipe } from '../../../../../shared/pipes/number-separator.pipe';
import { EntityPopup, PopupInfoItem } from './entity-popup.interface';

export class BalsaPopup implements EntityPopup {
  private formatNumber = new FormatNumberPipe();
  private datePipe = new DatePipe('es-ES');

  constructor(private entity: any) {}

  getBadgeText(): string {
    return '';
  }

  getInfoItems(): PopupInfoItem[] {
    const formattedDate = this.datePipe.transform(
      this.entity.current_datetime,
      'dd/MM/yyyy HH:mm:ss'
    );

    return [
      {
        icon: 'humidity_mid',
        label: 'Cantidad de agua embalsada',
        value: this.entity.capacitance
          ? this.entity.current_accumulated?.toFixed(2)
          : null,
        unit: this.entity.current_level
          ? `m³ (${this.formatNumber.transform(this.entity.current_level)}% de la capacidad)`
          : 'm³',
      },
      {
        icon: 'water',
        label: 'Caudal de salida',
        value: this.entity.current_flow,
        unit: 'm³/h',
        date: formattedDate,
      },
      {
        icon: 'readiness_score',
        label: 'Última lectura',
        value: this.entity.current_accumulated,
        unit: 'm³',
        date: formattedDate,
      },
    ];
  }
}
